module.exports = __webpack_public_path__ + "static/media/orientation.745bb3b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venueStatus/orientation.svg
// module id = 252
// module chunks = 1